import React, { Component } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import "bootstrap/dist/css/bootstrap.css";
import Router from "./Router";
import store from "./store";
// import ScrollToTop from "./ScrollToTop";
import { config as i18nextConfig } from "../../translations";
import "../../scss/app.scss";
// import { inProgress } from "../../shared/api-client";
import Loader from "./Loader";

i18next.init(i18nextConfig);

class App extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      loaded: false,
      progressPer: 0,
      progressCount: -1,
    };
  }

  componentDidMount() {
    window.addEventListener("load", () => {
      this.setState({ loading: false, loaded: true });
      // setInterval(() => {
      //   if (inProgress === 0) {
      //     this.setState({ progressPer: 100, progressCount: inProgress });
      //   } else if (this.state.progressPer < inProgress * 10) {
      //     this.setState({
      //       progressPer: inProgress * 10,
      //       progressCount: inProgress,
      //     });
      //   } else if (this.state.progressPer >= 100) {
      //     this.setState({ progressPer: 0, progressCount: inProgress });
      //   }
      // }, 500);
    });
  }

  render() {
    const { loaded, loading } = this.state;
    return (
      <Provider store={store}>
        <BrowserRouter basename="/limeproxy">
          <I18nextProvider i18n={i18next}>
            {/* <ScrollToTop> */}
            {!loaded && (
              <div className={`load${loading ? "" : " loaded"}`}>
                <div className="load__icon-wrap">
                  <svg className="load__icon">
                    <path
                      fill="#4ce1b6"
                      d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"
                    />
                  </svg>
                </div>
              </div>
            )}
            <Loader progress={this.state.progressPer} />
            <div className="routerClass">
              <Router />
            </div>
            {/* </ScrollToTop> */}
          </I18nextProvider>
        </BrowserRouter>
      </Provider>
    );
  }
}

export default App;
